var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyJobsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86534 6.9421C5.05546 6.9421 3.58301 5.46965 3.58301 3.65977C3.58301 1.8499 5.05546 0.377441 6.86534 0.377441C8.67522 0.377441 10.1477 1.8499 10.1477 3.65977C10.1477 5.46965 8.67522 6.9421 6.86534 6.9421Z",
    fill: "#35435E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07525 8.2548C2.3553 8.2548 0.957031 9.65307 0.957031 11.373V13.6706C0.957031 13.9398 1.18023 14.163 1.44938 14.163H7.52169V12.0295C7.52169 10.7953 8.44075 9.7778 9.62895 9.60055C9.79963 9.10164 10.1213 8.6815 10.5349 8.37953C9.87841 8.19178 9.84296 8.2548 4.07525 8.2548Z",
    fill: "#35435E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5636 10.8809H14.7431V10.3886C14.7431 9.75507 14.2277 9.23975 13.5942 9.23975H11.9531C11.3196 9.23975 10.8043 9.75507 10.8043 10.3886V10.8809H9.98369C9.6607 10.8809 9.36989 11.0155 9.16113 11.2308L12.7737 13.1155L16.3862 11.2308C16.1774 11.0155 15.8866 10.8809 15.5636 10.8809ZM11.789 10.8809V10.3886C11.789 10.298 11.8625 10.2244 11.9531 10.2244H13.5942C13.6848 10.2244 13.7584 10.298 13.7584 10.3886V10.8809H11.789Z",
    fill: "#35435E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0006 14.1075C12.8581 14.1817 12.6874 14.1817 12.5456 14.1075L8.83398 12.1709V14.9839C8.83398 15.6173 9.34931 16.1327 9.9828 16.1327H15.5628C16.1963 16.1327 16.7116 15.6173 16.7116 14.9839V12.1709L13.0006 14.1075Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyJobsIcon);
export default __webpack_public_path__ + "static/media/my-jobs-icon.a5d8e6fdee5fb03e16a246a0b8db09a7.svg";
export { ForwardRef as ReactComponent };